module.exports = __webpack_public_path__ + "static/media/blob_top_1440.330e1589.png";